query MfaSessionIssueTypes($runId: ConditionID!) {
	issues(run_id_eq: $runId, deleted_eq: { value: false }) {
		issue_id
		type_name
		severity_name
		scan_name
	}
}
